import SpriteSymbol from "../../../../../../../sfra-webpack-builder/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../sfra-webpack-builder/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search16",
  "use": "search16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"search16\"><path d=\"m15.53 14.47-4-4a5.82 5.82 0 1 0-1.07 1.06l3.27 3.26a1 1 0 0 0 1.42 0ZM7 11.25A4.25 4.25 0 1 1 11.25 7 4.26 4.26 0 0 1 7 11.25Z\" fill=\"#2d272a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol